import { render } from "./Consent.vue?vue&type=template&id=0eec79d0&scoped=true"
import script from "./Consent.vue?vue&type=script&lang=js"
export * from "./Consent.vue?vue&type=script&lang=js"

import "./Consent.vue?vue&type=style&index=0&id=0eec79d0&lang=scss&child-component=Captcha"
import "./Consent.vue?vue&type=style&index=1&id=0eec79d0&lang=scss&scoped=true"

import exportComponent from "/data/tfs-agent-build/agent/_work/7/s/30-Frontend/Frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eec79d0"],['__file',"src/views/Consent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0eec79d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0eec79d0', __exports__)) {
    api.reload('0eec79d0', __exports__)
  }
  
  module.hot.accept("./Consent.vue?vue&type=template&id=0eec79d0&scoped=true", () => {
    api.rerender('0eec79d0', render)
  })

}


export default __exports__